<template>
    <div>
        <h2
            v-if="partner.partner_type_id === 2"
            id="produtos-mesmo-artista"
            class="h6 text-bold text-default-5 mb"
        >
            Mais produtos do mesmo artista
        </h2>
        <h2
            v-else-if="partner.partner_type_id === 1"
            id="produtos-mesma-colecao"
            class="h6 text-bold text-default-5 mb"
        >
            Mais produtos da mesma coleção
        </h2>
        <h2 v-else id="produtos-autorais" class="h6 text-bold text-default-5 mb">
            Mais produtos autorais
        </h2>
        <div>
            <ProductCreatorOtherProductsList
                id="creator-list"
                :products="products"
                :partner="partner"
                event-name="Product detail similar"
                list-class="product-horizontal-list product-horizontal-list-5 no-scrollbar"
                @scroll="scrollEvent = $event"
            />
            <HorizontalScrollbar
                v-if="products.length > 2"
                :scroll-event="scrollEvent"
                class="hidden-not-touch"
                :id-list="'creator-list'"
            />
        </div>
    </div>
</template>
<script>
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar';
    import ProductCreatorOtherProductsList from './ProductCreatorOtherProductsList';
    import ProductList from '../common/ProductList.vue';

    export default {
        name: 'ProductCreatorOtherProducts',

        components: { ProductList, ProductCreatorOtherProductsList, HorizontalScrollbar },

        props: {
            products: {
                type: Array,
                required: true,
            },
            partner: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                scrollEvent: null,
            };
        },
    };
</script>
